export interface CheckboxRule {
    name: string;
    checked: boolean;
    required: string[];
    activated: string[];
}
